'use client';

import { useMemo } from 'react';
import useSWR from 'swr';
import { getAlerts } from '@/lib/api-client';
import { useAuth } from '@/context/AuthContext';

/**
 * Shared set of symbols (UPPERCASE) the signed-in user has an ACTIVE price
 * alert on — the alert-bell badge source. Gated on auth (key=null for anons,
 * so SWR never fires the 401-ing /alerts request). One deduped fetch.
 */
const EMPTY: Set<string> = new Set();

export function useAlertSymbols(): Set<string> {
  const { user } = useAuth();
  const { data } = useSWR(user ? 'price-alerts/active-symbols' : null, getAlerts, {
    revalidateOnFocus: false,
    dedupingInterval: 60_000,
  });
  return useMemo(
    () => new Set((data ?? []).filter((a) => a.active).map((a) => a.symbol.toUpperCase())),
    [data],
  );
}
